import ActionsForm from '@/shared/mixins/actionsForm'
import VueHtml2pdf from 'vue-html2pdf'
import cabecalhoPng from '../../../../../../../../../static/img/qma/cabecalho_relatorioQMA_landscape.png'
// import aprReport from '@/shared/http/repositories/business/aprReport'
// import reportQmaRepository from '@/shared/http/repositories/business/qmaReportRepository.js'
// import { toast, loading } from '@/shared/utils/UIHelper'

export default {
  name: 'qmaReportTable',
  components: {VueHtml2pdf},
  mixins: [ActionsForm],
  props: ['formSearch', 'dataRelatoioQma', 'report', 'dataRelatoioQmaLength', 'contagemPendentes', 'filtros'],
  data () {
    return {
      dataFormatada: '',
      quantitativos: {},
      dados: []
    }
  },
  computed: {
    nomeArquivo () {
      return `Relatório QMA - ${this.report === 0 ? 'LV' : this.report === 1 ? 'PIT' : this.report === 2 ? 'PIVS' : ''} - ${this.dataFormatada}`
    }
  },
  mounted () {
    this.dataFormatadaPdf()
    this.groupedData()
  },
  methods: {
    groupedData () {
      let chunks = []
      for (let i = 0; i < this.dados.length; i += 15) {
        chunks.push(this.dados.slice(i, i + 15))
      }
      return chunks
    },
    dataFormatadaPdf () {
      var dataAtual = new Date()
      var ano = dataAtual.getFullYear()
      var mes = ('0' + (dataAtual.getMonth() + 1)).slice(-2)
      var dia = ('0' + dataAtual.getDate()).slice(-2)
      this.dataFormatada = dia + '/' + mes + '/' + ano
    },
    createImageHeaderFooter (imgHref) {
      const img = document.createElement('img')
      img.src = imgHref
      img.style.border = 'none'
      return img
    },
    generatePDF () {
      this.$refs.html2Pdf.generatePdf()
    },
    async abrirNovaGuia ({ html2pdf, options, pdfContent }) {
      const headerImage = new URL(cabecalhoPng, window.location.origin)
      const headerPdf = this.createImageHeaderFooter(headerImage.href)
      options.margin = [1.1, 0, 0.5, 0]
      html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages()
        for (let i = 1; i <= totalPages; i++) {
          pdf.addImage(headerPdf, 'PNG', 0, 0, 12, 0)
          pdf.setPage(i)
          pdf.setFillColor(28, 98, 40)
          pdf.rect(0, pdf.internal.pageSize.getHeight() - 0.4, pdf.internal.pageSize.getWidth(), 10, 'F')
          pdf.setTextColor('#fff')
          pdf.setFont('Helvetica', 'normal') // Set font to normal for the next part
          pdf.setFontSize(10)
          pdf.setFont('Helvetica', 'bold')
          pdf.text('Zopone - ', 0.3, pdf.internal.pageSize.getHeight() - 0.15)
          pdf.text(
            // 'Relatório QMA - ' + this.report === 0 ? 'LV' : this.report === 1 ? 'PIT' : this.report === 2 ? 'PIVS' : '' + this.dataFormatada,
            this.nomeArquivo,
            0.90,
            pdf.internal.pageSize.getHeight() - 0.15
          )
          pdf.setFont('Helvetica', 'normal')
          pdf.text(
            'Pág ',
            10.7,
            pdf.internal.pageSize.getHeight() - 0.15
          )
          pdf.setFont('Helvetica', 'bold')
          pdf.text(
            i + ' de ' + totalPages,
            11,
            pdf.internal.pageSize.getHeight() - 0.15
          )
        }
      }).save()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaReport/components/qmaReportTable/components/qmaReportPdf/qmaReportPdf.js